import { 
  PlayArrow as DraftIcon,
  Approval as ApprovalIcon,
  PostAdd as PostableIcon,
  Cancel as RejectedIcon,
} from '@mui/icons-material';

// Healthcare-professional color scheme with medical industry standards
export const STATUS_CONFIGS = {
  Draft: { 
    icon: DraftIcon, 
    color: '#3b82f6',
    bgColor: '#eff6ff',
    displayName: 'Draft',
    description: 'New writeoff requests' 
  },
  InApproval: { 
    icon: ApprovalIcon, 
    color: '#f59e0b',
    bgColor: '#fffbeb',
    displayName: 'In Approval',
    description: 'Pending approval' 
  },
  MyApprovals: { 
    icon: ApprovalIcon, 
    color: '#7c3aed',
    bgColor: '#f3e8ff',
    displayName: 'My Approvals',
    description: 'Assigned to me' 
  },
  Postable: { 
    icon: PostableIcon, 
    color: '#06b6d4',
    bgColor: '#f0fdfa',
    displayName: 'Postable',
    description: 'Ready to post' 
  },
  Rejected: { 
    icon: RejectedIcon, 
    color: '#ef4444',
    bgColor: '#fef2f2',
    displayName: 'Rejected',
    description: 'Denied requests' 
  }
};
